<template>
  <vs-popup :active="!!failure" title="ไม่สามารถสร้าง QR Code ได้"
            :button-close-hidden="true" class="qr-payment-alert">
    <div class="qr-alert-message" role="alert">
      <p>{{ safeMessage }} สอบถามเพิ่มเติมได้ที่ <span v-if="!hasPhone">โทร. 062-618-2112 หรือ </span>Line ID: @world.loan หรือ <a href="https://lin.ee/xdaaWb0" target="_blank" rel="noopener noreferrer">https://lin.ee/xdaaWb0</a></p>
    </div>
    <div class="qr-alert-actions">
      <vs-button @click="$emit('close')">ตกลง</vs-button>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'QrPaymentAlert',
  props: { failure: { type: Object, default: null } },
  computed: {
    safeMessage () {
      const failure = this.failure
      const validation = failure && !failure.networkError && Array.isArray(failure.graphQLErrors)
        && failure.graphQLErrors.find(item => item.extensions
          && item.extensions.code === 'create_qr_payment_failed'
          && typeof item.message === 'string' && item.message.trim())
      const message = validation ? validation.message.replace(/\s+/g, ' ').trim() : 'เกิดปัญหาในการดำเนินการ กรุณาลองอีกครั้งหรือติดต่อเจ้าหน้าที่'
      if (message === 'ไม่สามารถชำระเงินแบบปิดบัญชีได้ กรุณาติดต่อเจ้าหน้าที่ 062-618-2112') {
        return 'ไม่สามารถชำระเงินแบบปิดบัญชีผ่านช่องทางนี้ได้ กรุณาติดต่อเจ้าหน้าที่เพื่อดำเนินการ'
      }
      return message
    },
    hasPhone () {
      return /0\d[\d\s-]{7,}\d/.test(this.safeMessage)
    }
  }
}
</script>

<style scoped>
.qr-payment-alert { z-index: 60000; }
.qr-payment-alert >>> .vs-popup { width: 600px; max-width: calc(100vw - 32px); }
.qr-alert-message { user-select: text; -webkit-user-select: text; white-space: normal; overflow-wrap: anywhere; line-height: 1.8; }
.qr-alert-message a { text-decoration: underline; }
.qr-alert-actions { display: flex; justify-content: flex-end; margin-top: 20px; }
</style>
